<template>
  <div id="add-kata">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <div class="form-group">
          <input
            type="text"
            v-model="word"
            name="kata"
            value=""
            required
            class="form-control"
            placeholder="Masukkan Kata"
          />
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";

$.pgNotification = notif;
export default {
  name: "Addhashtag",
  data() {
    return {
      word: null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
    };
  },
  methods: {
    submitForm: function () {
      let self = this;
      let params = {
        word: this.$sanitize(this.word),
        id_project: this.id_project,
      };
      let api = process.env.VUE_APP_API_URL + "marked-words-add";
      this.$http
        .post(api, params)
        .then(function (response) {
          if (response.status == 200) {
            self.$parent.$parent.getKata();
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Kata berhasil ditambahkan!',
                position: "top",
                timeout: 4000,
                type: "success",
              })
              .show();
          }
        })
        .catch(function () {
          $("#modalSlideUp").modal("hide");
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan Kata!',
              position: "top",
              timeout: 4000,
              type: "danger",
            })
            .show();
        });
    },
  },
};
</script>